import React, { Component } from 'react';


export class FileUploader extends Component {

  constructor(props) {
    super(props);
    this.state = { value: this.props.text };

    // this.state.value=this.props.text;
    this.onChange = this.onChange.bind(this);

     this.textInput = null;
     this.textInputLabel = null;

     this.setTextInputRef = element => {
      this.textInput = element;
    };

    
    this.setTextInputLabelRef = element => {
      this.textInputLabel = element;
    };

  }

  onChange()
  {
     

    var fileName = this.textInput.value.split("\\").pop();

    console.log(this.textInput);

    this.textInputLabel.innerHTML =fileName;

    this.props.onFileChange(this.props.name,this.textInput.files[0]);
   // console.log(fileName);
    //$(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  }


  componentDidMount() {
  }


  render() {
 

    return (

      
      <div className="custom-file" style={{direction:'ltr'}}>
            <label className="custom-file-label" for="customFile" ref={this.setTextInputLabelRef}>انتخاب فایل</label>
          <input type="file" 
              className="custom-file-input" 
              id="customFile" 
              onChange={this.onChange}       
              ref={this.setTextInputRef}
              accept=".xlsx"
            />
      
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/elements/FileUploader.js